import { render } from "./TestRunner.vue?vue&type=template&id=12ef8799&scoped=true"
import script from "./TestRunner.vue?vue&type=script&lang=js"
export * from "./TestRunner.vue?vue&type=script&lang=js"

import "./TestRunner.vue?vue&type=style&index=0&id=12ef8799&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ef8799"]])

export default __exports__